import { render, staticRenderFns } from "./ProjectsPagePrimaryMarket.vue?vue&type=template&id=19ac43ce&"
import script from "./ProjectsPagePrimaryMarket.vue?vue&type=script&lang=js&"
export * from "./ProjectsPagePrimaryMarket.vue?vue&type=script&lang=js&"
import style0 from "./ProjectsPagePrimaryMarket.vue?vue&type=style&index=0&id=19ac43ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports